function CardCourse(course, index) {
  function createCardCourseText(title, value) {
    return `
      <p class="card-course__content-right-text">
        <span class="card-course__content-right-title">
          ${title}:
        </span>
        ${value}
      </p>
    `;
  }

  function createSeparator() {
    return `<span class="card-course__content-bottom-item-border"></span>`;
  }

  const cardContent = `
    <div class="card-course__content">
      <div class="card-course__content-left"></div>
      <div class="card-course__content-right">
        <h4 class="heading">${course?.title}</h4>
      </div>
    </div>
    <div class="card-course__content-bottom">
      <div class="card-course__content-bottom-item">
        ${createCardCourseText('NRC', course?.nrc)}
        ${createSeparator()}
        ${createCardCourseText('Sección', course?.section)}
        ${createSeparator()}
        ${createCardCourseText('Curso', course?.course)}
      </div>
    </div>
  `;

  const currentCard = `
    <div class="card-course ${
      index === 0 && 'is-active'
    } ${course?.modality?.toLowerCase()}" data-id="${course?.nrc}">
      ${cardContent}
    </div>
  `;
  return currentCard;
}
export default CardCourse;
